export default __webpack_public_path__ + "static/media/b8FnIRj5KP4.ea214ac1.png";